import { msg } from '../messages'
import * as Util from '../util'

const TITULO_ELEITOR_PATTERN = '^[0-9]{12,13}$'

function tituloEleitorRule(value: string): string {
  if (!isValid(value)) {
    return msg('tituloEleitorInvalid', value)
  }
  return null
}

function hasCorrectPattern(value: string) {
  return new RegExp(TITULO_ELEITOR_PATTERN).test(value)
}

function calculaDigVerificador(value: string, pesoInicial: number, isExcecao: boolean) {
  let dig = 0
  let peso = pesoInicial
  for (let i = 0; i < value.length; ++i) {
    dig += (value.charCodeAt(i) - 48) * peso--
  }
  dig = dig % 11
  if (dig === 0) {
    dig = isExcecao ? 1 : 0
  } else {
    dig = dig === 1 ? 0 : 11 - dig
  }
  return dig
}

function isValid(value: string): boolean {
  if (Util.isEmpty(value)) {
    return true
  }
  if (!hasCorrectPattern(value) || verificaTituloEleitorIgualZero(value)) {
    return false
  }
  const size = value.length
  const estado = value.substr(size - 4, 2)
  const isExcecao = estado === '01' || estado === '02'
  const digitosVerificadoresExperados = value.substr(size - 2, 2)

  const digitoVerificador1 = calculaDigVerificador(value.substr(0, 8), 9, isExcecao)
  const digitoVerificador2 = calculaDigVerificador(value.substr(8, 3), 4, isExcecao)

  return '' + digitoVerificador1 + digitoVerificador2 === digitosVerificadoresExperados
}
function verificaTituloEleitorIgualZero(tituloEleitorValue) {
  if (tituloEleitorValue === '0000000000000' || tituloEleitorValue === '000000000000') {
    return true
  }
  return false
}

export const tituloEleitor = [tituloEleitorRule]
